import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import URL from "../../../constant/URL";
import TYPE from "../../../constant/TYPE";
import AiDiagnosisTest from "./aiDiagnosisTest/AiDiagnosisTest";
import Guide from "./courseLearning/Guide";
import List from "./courseLearning/List";
import LearningNote from "./learningNote/LearningNote";
import CompleteLoading from "./courseLearning/CompleteLoading";
import LearningNoteGM from "./learningNote/GM/LearningNoteGM";
import EntryCheck from "../../provider/EntryCheck";
import LearningNoteGB from "../../global/learningNote/LearningNoteGB";

const CourseLearning = () => {

  const routeMatch = useRouteMatch();

  const mount = () => {

    localStorage.setItem( 'learning.id', TYPE.LEARNING.COURSE );

  };

  React.useEffect( mount, [] );

  return <Route path={ `${ routeMatch.url }/:depth3` }><Children /></Route>;

};

const Children = () => {

  const routeMatch = useRouteMatch();
  const id = window.location.pathname.slice( `${ routeMatch.url }/`.length );

  return (

    <Switch>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.I }><AiDiagnosisTest /></Route>
      <Route path={ URL.COURSE_LEARNING.GUIDE }><Guide /></Route>
      <Route path={ URL.COURSE_LEARNING.LIST }><List id={ id } /></Route>
      <Route path={URL.COURSE_LEARNING.LEARNING_NOTE}>
        <EntryCheck
          WJTB={<LearningNote id={id} />}
          GLOBAL01={<LearningNoteGB id={id} />}
          GM={<LearningNoteGM />}
          CP={<LearningNoteGM />}
          GM_APP={<LearningNoteGM />}
        />
      </Route>
      <Route path={ URL.COURSE_LEARNING.COMPLETE_LOADING }><CompleteLoading /></Route>
    </Switch>

  );

};

export default CourseLearning;
